/**
 * Export component file to be used on project
 */

import Payment from './Payment';
export default Payment;